export default "__VITE_ASSET__BpA5n5_l__"